// 实训中心  
import {
  pythonEditorVideo01,
  pythonEditorVideo02,
  pythonEditorVideo03,
  pythonEditorVideo04,
} from '@/utils/images.js'

const primaryGuide = [
  {
    id: 'guide-1',
    rightnavs: '快速上手指引',
    title: '第一步，输入代码，编写程序',
    content: '',
    note: '',
    level: 1,
    children: [
      {
        id: 'guide-1-1',
        level: 2,
        content: '',
        note: '',
        imgUrlList:[],
        videoUrlList: [
          {
            url: pythonEditorVideo01,
            label: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-2',
    level: 1,
    title: '第二步，查看算法模型API文档，调用算法模型',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-2-1',
        level: 2,
        content: '',
        note: '',
        imgUrlList:[],
        videoUrlList: [
          {
            url: pythonEditorVideo02,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-3',
    level: 1,
    title: '第三步，完善代码程序',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-3-1',
        level: 2,
        content: '',
        note: '',
        imgUrlList:[],
        videoUrlList: [
          {
            url: pythonEditorVideo03,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-4',
    level: 1,
    title: '第四步，运行项目程序，显示结果',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-4-1',
        level: 2,
        content: '',
        note: '',
        imgUrlList:[],
        videoUrlList: [
          {
            url: pythonEditorVideo04,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },

  {
    level: 1,
    footer:
      '更多关于AI-T编辑器（代码模式）的学习使用，可查看API文档详情内容哦！现在，快快去创作吧~',
  },
]

//附件
const secodeGuide = []
export default {
  primaryGuide,
  secodeGuide,
}
